import React from "react"

import "./ConfirmPatientMatch.css"
import { confirmPatientMatch } from  "../../../api/participant/confirmPatientMatch"
import { makeUrl } from "../../../api/makeUrl"
import LocalizedText from "../../presentational/LocalizedText";

export type ConfirmPatientMatchProps = {
    baseUrl: string,
    model: any
}

export default function ConfirmPatientMatch(props: ConfirmPatientMatchProps): React.ReactElement {
    const [isConfirmDialogVisible, setConfirmDialogVisible] = React.useState<boolean>(false);
    const brandLogo= props.model.AccountCreationModel.BrandLogo?.startsWith("~") ? makeUrl(props.model.AccountCreationModel.BrandLogo) : props.model.AccountCreationModel.BrandLogo;
    const providerLogo = props.model.AccountCreationModel.ProviderHasLogo && `${props.baseUrl}/api/v1/delegated/externalaccountproviders/${props.model.AccountCreationModel.ProviderID}/logo`;


    function cancelMatch() {
        window.location = props.model.FinalRedirectUrl?.replace("success=true", "success=false");
    }
    
    function showConfirmation() {
        setConfirmDialogVisible(true);
    }

    function hideConfirmation() {
        setConfirmDialogVisible(false);
    }
    
    async function confirmMatch() {
        try {
            await confirmPatientMatch({ StateKey: props.model.StateKey, PatientMappings: [
                    {
                        SourcePatientID: props.model.SourcePatients[0].Identifier,
                        TargetPatientID: props.model.FamilyPatients[0].ID,
                        RelationshipType: "Self"
                    }
                ]
            });
            window.location = props.model.FinalRedirectUrl;
        }
        catch (error) {
            console.error(error);
        }
    }

    return (
        <div className="confirm-patient-match-wrapper">
            {isConfirmDialogVisible &&
                <div className="modal-container">
                    <div className="rk-modal modal-prompt-container">
                        <div className="modal-prompt">
                            <b><LocalizedText textKey="confirm-patient-match-modal-title" /></b>
                            <div className="modal-statement">
                                <LocalizedText textKey="confirm-patient-match-modal-text" />
                            </div>
                            <div className="modal-actions" ng-show="!vm.spinnerIsVisible">
                                <a className="modal-action modal-confirm"
                                   onClick={confirmMatch}><LocalizedText textKey="confirm-patient-match-modal-yes" /></a>
                                <a className="modal-action modal-cancel"
                                   onClick={hideConfirmation}><LocalizedText textKey="confirm-patient-match-modal-no" /></a>
                            </div>
                        </div>
                        <div className="modal-overlay"></div>
                    </div>
                </div>
            }
            {providerLogo &&
                <div className="logos">
                    <div className="logo-wrap"><img src={providerLogo}></img></div>
                </div>
            }
            <h2><LocalizedText textKey="confirm-patient-match-body-title" /></h2>
            <div className="callout">
                <LocalizedText textKey="confirm-patient-match-body-text" />
            </div>
            <div className="patient-info">
                <div className="title">
                    MyDataHelps
                    { brandLogo &&
                        <img src={brandLogo}></img>
                    }
                </div>
                <div className="details">
                    <div>{props.model.FamilyPatients[0]?.Description}</div>
                    <div>{props.model.FamilyPatients[0]?.DemographicFields?.DateOfBirth}</div>
                    <div>{props.model.FamilyPatients[0]?.DemographicFields?.Gender}</div>
                </div>
            </div>
            <div className="patient-info">
                <div className="title">
                    {props.model.AccountCreationModel.ProviderName}
                    {props.model.AccountCreationModel.ProviderHasLogo && <img src={providerLogo}></img>}
                </div>
                <div className="details">
                    <div>{props.model.SourcePatients[0]?.Description}</div>
                    <div>{props.model.SourcePatients[0]?.DemographicFields?.DateOfBirth}</div>
                    <div>{props.model.SourcePatients[0]?.DemographicFields?.Gender}</div>
                </div>
            </div>
            <div className="buttons">
                <button className="confirm-button mdhui-button" onClick={showConfirmation}><LocalizedText textKey="confirm-patient-match-body-yes" /></button>
                <button className="cancel-button" onClick={cancelMatch}><LocalizedText textKey="confirm-patient-match-body-no" /></button>
            </div>
        </div>
    );
}